module.exports = __webpack_public_path__ + "static/media/medical_files_placeholder.798b8bfd.png";